<template>
    <b-overlay
        :show="isLoading"
        spinner-variant="secondary"
        spinner-type="grow"
        spinner-small
    >
        <div class="editor-wrapper">
            <p v-if="question" v-html="question" class="mb-3" />
            <b-form-textarea
                v-model.trim="text"
                class="w-100"
                :placeholder="this.trans('courses.write_a_think')"
                @blur="submit"
            />
        </div>
    </b-overlay>
</template>

<script>
    export default {
        name: "FullScreenEditorInline",
        props: {
            question: String,
            promptId: String,
            textContent: String,
        },
        data() {
            return {
                isLoading: true,
                text: this.textContent
            }
        },
        mounted() {
            this.text = this.textContent ? this.textContent : '';
            this.isLoading = false;
        },
        methods: {
            submit(e) {
                this.$emit('submit', {answers: this.text});
                this.$parent.$emit('nextStep');
            }
        }
    }
</script>
